import { navigate } from "gatsby";

import { PaymentState } from "@/autoGeneratedGlobalTypes";
import { getSuccessUrl } from "@/utils/urlUtils";

import { ROBOKASSA_PAYMENT_FROM_PROFILE_PAGE } from "./constants";
import { ProcessRobokassaPaymentLinksType } from "./types";

export const processRobokassaPaymentLinks = (
  { link, statusPayment, dataAboutPayment }: ProcessRobokassaPaymentLinksType,
) => {
  const url = new URL(link);
  const pathAfterDomain = url.href.replace(`${url.origin}/`, "");
  const successUrlForRedirect = getSuccessUrl(url.search);

  switch (true) {
    case pathAfterDomain.includes(ROBOKASSA_PAYMENT_FROM_PROFILE_PAGE): {
      if (statusPayment === PaymentState.Success) {
        navigate(successUrlForRedirect || `/profile/balance`, { state: { showPaymentAnimation: true, resultData: dataAboutPayment } });
        break;
      }
      navigate(ROBOKASSA_PAYMENT_FROM_PROFILE_PAGE);
      break;
    }
    default:
      navigate(`/${pathAfterDomain}&request=${dataAboutPayment.state.toLowerCase()}`, { replace: true });
      break;
  }
};
